import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { ClientReportPage } from "@/features/clientreport/ClientReportPage";

const search = z.object({ month: z.string().regex(/^\d{4}-\d{2}$/).optional() });

export const Route = createFileRoute("/_app/reports/clients/$client")({ validateSearch: search, component: Page });

function Page() {
  const { client } = Route.useParams();
  return <ClientReportPage slug={client} search={Route.useSearch()} />;
}
